<template>
  <div
    class="modal fade"
    id="sys_reviewstation_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title" id="myModalLabel">基站审核</h4>
        </div>
        <!-- modal-body-->
        <div class="modal-body form-horizontal">
          <div class="form-group">
            <label class="col-sm-3 control-label">经度</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoStation.req_data.stst_longitude"
              />
            </div>
            <label class="col-sm-3 control-label">纬度</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoStation.req_data.stst_latitude"
              />
            </div>
          </div>
          <div class="form-group" v-if="InfoAdd">
            <label class="col-sm-3 control-label">所在片区</label>
            <div class="col-sm-3">
              <select
                class="chosen-reviewStation-layer"
                name
                id
                v-model="layerid"
              >
                <option value>请选择图层</option>
                <option
                  v-for="(item, index) in layerlist"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <div id="station_map"></div>
          </div>
        </div>
        <!-- modal-footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            @click="conclusion('reject')"
          >
            拒绝
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="conclusion('pass')"
          >
            通过
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AMap from "AMap";

var map;
var marker;
export default {
  data() {
    return {
      layerlist: [],
      layerid: "",
    };
  },
  props: ["infoStation", "InfoAdd"],
  mounted: function () {},
  methods: {
    loadData: function () {
      var self = this;
      console.log("InfoAdd---", self.InfoAdd);
      map = new AMap.Map("station_map", {
        center: [
          self.infoStation.req_data.stst_longitude,
          self.infoStation.req_data.stst_latitude,
        ],
        resizeEnable: true,
        zoom: 16,
      });
      marker = new AMap.Marker({
        map: map,
        position: [
          self.infoStation.req_data.stst_longitude,
          self.infoStation.req_data.stst_latitude,
        ],
        zIndex: 101,
        size: new AMap.Size(10, 10),
        offset: new AMap.Pixel(-20, -20),
      });

      $(".chosen-reviewStation-layer")
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: "200px",
        })
        .change(function () {
          self.layerid = $(".chosen-reviewStation-layer").val();
        });

      // 获取所有片区 增加基站选择片区
      self.global.axiosGet(self, "layers/", function (res) {
        console.log("获取所有片区", res);
        self.layerlist = res;
        console.log("--self.layerlist", self.layerlist);
        setTimeout(function () {
          $(".chosen-reviewStation-layer").trigger("chosen:updated");
        }, 500);
      });
    },
    // 处理结果
    conclusion: function (type) {
      var self = this;
      var axiosPutData = {};
      // 只有新增基站需要选择片区
      if (self.InfoAdd == true) {
        // 增加基站
        if (self.layerid == "") {
          alert("请选择片区");
          return;
        }
        axiosPutData = { conclusion: type, layer_id: self.layerid };
      } else {
        axiosPutData = { conclusion: type };
      }
      self.global.axiosPut(
        self,
        "info_change/" + self.infoStation.id + "/",
        { conclusion: type, layer_id: self.layerid },
        function (res) {
          console.log("-----处理结果", res);
          if (res.status == "success") {
            alert("操作成功");
            $("#sys_reviewstation_modal").modal("hide");
            $("#info_atptable").bootstrapTable("refresh");
          } else {
            alert("操作失败");
          }
        },
        function () {
          alert("操作失败!");
        }
      );
    },
  },
};
</script>
<style scoped>
#station_map {
  margin: 30px;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/informationAudit/reviewStation.vue